import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";
import { mediaUrl, useSiteData } from "../lib/siteApi";
import { groupServices } from "../lib/catalog";

export default function Navbar() {
  const [scroll, setScroll] = useState(false);
  const [manu, setManu] = useState(false);
  const [openDrop, setOpenDrop] = useState("");
  const dropTimer = useRef(null);
  const location = useLocation();
  const site = useSiteData();
  const company = site.settings?.company || {};
  const logos = {
    light: mediaUrl(company.logoUrl) || logoDark,
    dark: mediaUrl(company.logoDarkUrl) || mediaUrl(company.logoUrl) || logoLight,
  };
  const services = groupServices(site.services || []);
  const categoryOrder = ["photovoltaic", "realestate", "emobility"];
  const serviceCats = Object.values(services).sort((a, b) => {
    const ai = categoryOrder.indexOf(a.key);
    const bi = categoryOrder.indexOf(b.key);
    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
  });

  useEffect(() => {
    const onScroll = () => setScroll(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setManu(false);
    setOpenDrop("");
  }, [location.pathname]);

  const close = () => {
    setManu(false);
    setOpenDrop("");
  };

  return (
    <div>
      <nav className={`navbar ${scroll ? "is-sticky" : ""}`} id="navbar">
        <div className="container relative flex flex-wrap items-center justify-between">
          <Link
            className="navbar-brand md:me-8 relative z-[70] cursor-pointer"
            to="/"
            onClick={() => {
              close();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            aria-label="RENERG home"
          >
            <img src={logos.light} className="inline-block dark:hidden w-40 md:w-52" alt="RENERG" />
            <img src={logos.dark} className="hidden dark:inline-block w-40 md:w-52" alt="RENERG" />
          </Link>

          <div className="nav-icons flex items-center lg_992:order-2 ms-auto md:ms-8 gap-2">
            <Link to="/contact" className="nav-quote-btn hidden lg_992:inline-flex" onClick={close}>
              Get a quote
            </Link>
            <button
              type="button"
              data-collapse="menu-collapse"
              className="collapse-btn mobile-menu-btn lg_992:hidden"
              onClick={() => setManu(!manu)}
              aria-label={manu ? "Close menu" : "Open menu"}
            >
              <span className="sr-only">Navigation Menu</span>
              <i className={`mdi ${manu ? "mdi-close" : "mdi-menu"} text-[28px] leading-none`} />
            </button>
          </div>

          <div className={`navigation lg_992:order-1 lg_992:flex ${manu ? "block" : "hidden"} lg_992:block ms-auto`} id="menu-collapse">
            <ul className="navbar-nav" id="navbar-navlist">
              <li className="nav-item ms-0">
                <Link className={`nav-link ${location.pathname === "/" ? "active" : ""}`} to="/" onClick={close}>Home</Link>
              </li>
              <li className="nav-item ms-0">
                <Link className={`nav-link ${location.pathname.startsWith("/about") ? "active" : ""}`} to="/about" onClick={close}>About</Link>
              </li>

              <li
                className={`nav-item ms-0 nav-drop ${openDrop === "services" ? "is-open" : ""}`}
                onMouseEnter={() => {
                  if (dropTimer.current) clearTimeout(dropTimer.current);
                  setOpenDrop("services");
                }}
                onMouseLeave={() => {
                  if (window.innerWidth < 992) return;
                  if (dropTimer.current) clearTimeout(dropTimer.current);
                  dropTimer.current = setTimeout(() => setOpenDrop(""), 200);
                }}
              >
                <button type="button" className={`nav-link nav-drop-btn ${location.pathname.startsWith("/services") ? "active" : ""}`} onClick={() => { if (window.innerWidth < 992) setOpenDrop(openDrop === "services" ? "" : "services"); }}>
                  Services <span className="nav-caret">▾</span>
                </button>
                <div className="nav-drop-panel nav-drop-wide">
                  <div className="nav-drop-inner">
                    <div className="nav-drop-top">
                      <div>
                        <p className="nav-drop-kicker">What we do</p>
                        <p className="nav-drop-title">Solar, green buildings and e-mobility</p>
                      </div>
                      <Link to="/services" className="nav-drop-all" onClick={close}>View all services →</Link>
                    </div>
                    <div className="nav-drop-grid">
                      {serviceCats.map((cat) => (
                        <div key={cat.key} className="nav-drop-col">
                          <Link to={`/services/category/${cat.key}`} className="nav-drop-head" onClick={close}>
                            <span className="nav-drop-icon" aria-hidden="true">{cat.icon}</span>
                            <span>{cat.title}</span>
                          </Link>
                          <div className="nav-drop-links">
                            {cat.services.map((item) => (
                              <Link key={item.id} to={`/services/${item.id}`} className="nav-drop-link" onClick={close}>{item.title}</Link>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </li>

              <li className="nav-item ms-0">
                <Link className={`nav-link ${location.pathname.startsWith("/projects") ? "active" : ""}`} to="/projects" onClick={close}>Projects</Link>
              </li>

              <li className="nav-item ms-0">
                <Link className={`nav-link ${location.pathname.startsWith("/contact") ? "active" : ""}`} to="/contact" onClick={close}>Contact</Link>
              </li>
              {(site.pages || []).filter((page) => page.showInNav).map((page) => (
                <li className="nav-item ms-0" key={page.id}>
                  <Link className="nav-link" to={`/pages/${page.slug}`} onClick={close}>{page.title}</Link>
                </li>
              ))}
              <li className="nav-item ms-0 lg_992:hidden">
                <Link className="nav-link" to="/contact" onClick={close}>Get a quote</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
